import { Component, Inject, OnInit, Input, Output, EventEmitter, ViewChildren } from "@angular/core";

import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from "src/app/Service/notification.service";
import { GridComponent } from '@progress/kendo-angular-grid';
import { DynamickendoService } from './Service/Dynamic-kendo.service';


@Component({
    selector: 'app-Dynamic-kendo-Grid',
    templateUrl: './Dynamic-kendo-Grid.component.html',
    styleUrls: ['./Dynamic-kendo-Grid.component.css']
})
export class DynamickendoGridComponent implements OnInit {
    //@Input() DataList: any[];
    public _DataList!: any[];
    @Input() grdSettings!: any[];

    get DataList(): any[] {
        return this._DataList;
    }
    @Input() set DataList(value: any[]) {
        if (!!value && typeof value == "object") {
            this._DataList = value;
            // this.loadInitialData();
            //  this._DataList.forEach((x) => {
            //     let obj =x;
            //     let binding : any= {} ;
            //     this.grdSettings.forEach((s,i)=>{
            //         if(obj.hasOwnProperty(s.field))
            //         {
            //             let property = s.field;
            //             binding[s.field] = obj[property];
            //             x["value"+i] =  x[s.field];
            //         }
            //         else{
            //         x["value"+i] = "";
            //         binding[s.field] ="";
            //         }
            //     })
            //     x.Header = Object.keys(binding);
            //     x.value = Object.values(binding);
            // });
        }
    }
    @Input() PageName: any;
    @Input() Url: any;
    @Input() callbackFunction!: (IconData: any, ItemData: any) => boolean;
    @Output() VisibleEvent = new EventEmitter();
    @Output() ClickEvent = new EventEmitter();
    @ViewChildren('grd') public gridSettingDetails!: GridComponent;
    enableFilter = false;
    enableFullscreen = false;
    GridListIcons: any[] = [];
    GridHeaderIcons: any[] = [];
    GridToogleButtons: any[] = [];
    HeaderListIcons: any[] = [];
    constructor(private _DynamickendoService: DynamickendoService, private _commonService: CommonService, private _notificationService: NotificationService) {

    }
    /**
     * ngOnInit - Angular Lifecycle hook
     */
    ngOnInit() {
        this.GridListIcons = this._DynamickendoService.getIcondetails(this.PageName);
        this.GridHeaderIcons  = this.GridListIcons.filter(x=>x.Isheader);
        this.GridToogleButtons  = this.GridListIcons.filter(x=>x.Istoogle);  
        if (this.grdSettings) {
            this.grdSettings = this.grdSettings.map((x) => ({
                MemberID: x.MemberID,
                MenuId: x.MenuId,
                order: x.order,
                width: x.width,
                field: x.field,
                title: x.title,
                icons: this.GridListIcons
            }));
        }
        // if(this.DataList)
        // this.DataList.forEach(x => {
        //     let obj =x;
        //     x.Header = Object.keys(obj);
        //     x.value = Object.values(obj);
        // });
    }

    /**
     * Get MemForm Controls value
     * @param controlName ControlName
     */

    Visible(Icondata: any, Itemdata: any): boolean {
        return this.callbackFunction(Icondata, Itemdata);


    }
    IconClick(Icondata: any, Itemdata ?: any) {
        let data: any = {
            Icondata: Icondata,
            Itemdata: Itemdata
        }
        this.ClickEvent.emit(data);
    }

    /**
* Toggle filter
*/
    toggleFilter() {
        this.enableFilter = !this.enableFilter;
    }

    /**
       * Full screen
       */
    toggleFullscreen() {
        this.enableFullscreen = !this.enableFullscreen;
    }
    gridSettings() {
        this._DynamickendoService.gridSettings(this.gridSettingDetails,this.Url);
    }
    loadInitialData() {

    }
}
